import { useMutation } from '@apollo/client';
import { useState } from 'react';
import UPDATE_USER_INFO from '../graphql/mutations/update-user-info';
import { formatRut } from '../helpers';
import useBooleanState from './useBooleanState';
import useGetUser from './useGetUser';
import useSelectedCompany from './useSelectedCompany';

const emptyObject = (obj) => Object.values(obj).every((value) => value === '');

const useProfileInfoForm = () => {
  const userObject = useGetUser();
  const selectedCompany = useSelectedCompany();
  const [errorMsg, setErrorMsg] = useState({});
  const [attributeChanges, setAttributeChanges] = useState({});
  const [snackbarOpen, toggleSnackbar] = useBooleanState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [disabledEdit, toggleDisabledEdit] = useBooleanState(true);
  const [formValues, setFormValues] = useState({});

  const [updateUserInfo, { loading }] = useMutation(UPDATE_USER_INFO, {
    onError: () => {
      setSnackbarMessage(
        'Ha ocurrido un error. Revise que los datos sean correctos e intente nuevamente.',
      );
      toggleSnackbar();
    },
    onCompleted: () => {
      setAttributeChanges({});
      setSnackbarMessage('Sus cambios fueron guardados exitosamente.');
      toggleSnackbar();
    },
  });

  const handleOnClick = (topRef) => {
    if (Object.keys(attributeChanges).length) {
      updateUserInfo({ variables: attributeChanges });
    } else if (topRef?.current) {
      topRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    toggleDisabledEdit();
  };

  const handleCancel = () => {
    toggleDisabledEdit();
    setAttributeChanges({});
    setFormValues((prev) => ({ ...prev, ...userObject }));
  };

  const disableSaveButton = (
    !((emptyObject(attributeChanges) ? !emptyObject(errorMsg) : emptyObject(errorMsg)))
  );

  const initializeFormValues = (profileInfo) => {
    setFormValues(
      profileInfo.reduce((acc, curr) => {
        if (curr.type === 'rut') {
          acc[curr.attributeName] = formatRut(curr.getAttribute(userObject));
        } else {
          acc[curr.attributeName] = curr.getAttribute(userObject);
        }
        return acc;
      }, {}),
    );
  };

  return {
    userObject,
    formValues,
    setFormValues,
    errorMsg,
    setErrorMsg,
    disabledEdit,
    loading,
    snackbarOpen,
    snackbarMessage,
    toggleSnackbar,
    handleOnClick,
    handleCancel,
    disableSaveButton,
    setAttributeChanges,
    initializeFormValues,
    selectedCompany,
  };
};

export default useProfileInfoForm;
